module.exports = __webpack_public_path__ + "img/ic-chev-s.2b8b7136.svg";